import React, { Fragment } from 'react';
import { Button, Checkbox, Form, Header, Input, Loader, Popup, Segment, Table } from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import { Redirect } from 'react-router-dom';

import axios from 'axios';
import SelectOrgUnit from '../SelectOrgUnit';

export default class Systematization extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],

            editMode: false,
            addNewSystematization: false,
            showPosition: false,
            active: true,
            name: null,
            nameErr: false,

            id: null,
            optLock: null,
            loading: true
        };
        this.getSystematization = this.getSystematization.bind(this);
        this.delete = this.delete.bind(this);
        this.edit = this.edit.bind(this);
        this.add = this.add.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this.getSystematization();
    }

    getSystematization() {
        this.setState({ loading: true });
        axios({
            method: 'get',
            url: localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:' ? `systematization/${parseInt(localStorage.getItem('orgUnitId'))}/` : 'systematization/',
        })
            .then(res => {
                this.setState({
                    data: res.data, loading: false
                });
            })
            .catch(err => {
                console.log('Failed to fetch systematization.');
            });
    }

    add() {
        if (!this.state.name) {
            toast('Morate unijeti naziv sistematizacije.');
            this.setState({ nameErr: true });
        } else {
            this.setState({ nameErr: false });

            let obj = {
                name: this.state.name
            };

            axios.post('systematization/add', { ...obj })
                .then(res => {
                    toast('Dodavanje sistematizacije je uspješno izvršeno.');
                    this.getSystematization();
                    this.setState({ addNewSystematization: false });
                })
                .catch(err => {
                    toast('Došlo je do greške! Dodavanje sistematizacije nije uspjelo.');
                });
        }
    }

    delete(id) {
        let obj = { id };

        axios.delete('systematization/delete', { data: obj })
            .then(res => {
                this.setState({
                    data: res.data, loading: false
                });
                toast('Brisanje sistematizacije je uspješno izvršeno.');
                this.getSystematization();
            })
            .catch(err => {
                toast('Došlo je do greške! Brisanje sistematizacije nije uspješno izvršeno.');
            });
    }

    edit() {
        let obj = {
            name: this.state.name,
            active: this.state.active,
            id: this.state.id,
            optLock: this.state.optLock
        };
        axios.put('systematization/edit', { ...obj })
            .then(res => {
                this.setState({
                    data: res.data, loading: false
                });
                toast('Izmjena istematizacije je uspješno izvršena.');
                this.setState({ editMode: false });
                this.getSystematization();
            })
            .catch(err => {
                toast('Došlo je do greške! Izmjena sistematizacije nije uspješno izvršena.');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        const { editMode } = this.state;
        if (this.state.showPosition) return <Redirect push to={{ pathname: '/sistematizacije/pozicije' }} />;

        return (

            <div>
                <h1>Sistematizacije</h1>
                <Segment.Group raised>
                    <Segment raised>
                        <Header as="h3">
                            Spisak sistematizacija
                        </Header>
                    </Segment>
                    <Segment clearing>
                        {localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:' && <SelectOrgUnit getSystematization={this.getSystematization} systematization />}

                        {(localStorage.getItem('orgUnitId') || localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') && <Fragment>
                            {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                                :
                                <Table celled selectable compac>
                                <Table.Header>
                                        <Table.Row>
                                        <Table.HeaderCell>Naziv sistematizacije</Table.HeaderCell>
                                        <Table.HeaderCell>Aktivna sistematizacija</Table.HeaderCell>
                                        {(this.state.editMode === false && !this.state.addNewSystematization && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:')
                                                ? <Table.HeaderCell as="th" verticalAlign="middle" textAlign="center">
                                                    <Popup
                                                        content="Dodaj sistematizaciju"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                icon="add"
                                                                size="small"
                                                                basic="true"
                                                                color="blue"
                                                                circular
                                                                onClick={() => this.setState({ addNewSystematization: true })}
                                                            />}
                                                    />
                                                </Table.HeaderCell> : <Table.HeaderCell />}
                                    </Table.Row>
                                    </Table.Header>
                                {this.state.data.length || this.state.addNewSystematization ? <Table.Body>
                                        {this.state.addNewSystematization && <Table.Row>
                                        <Table.Cell verticalAlign="middle">
                                                <Form>
                                                <Form.Field
                                                        required
                                                        error={this.state.nameErr}
                                                        control={Input}
                                                        name="name"
                                                        value={this.state.name}
                                                        onChange={this.handleInputChange}
                                                        placeholder="Unesite naziv sistematizacije"
                                                    />
                                            </Form>
                                            </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                                <Form>
                                                <Form.Field>
                                                        <Checkbox
                                                            checked={this.state.active}
                                                            label=""
                                                            value={this.state.active}
                                                            onChange={(e) => this.setState({ active: !this.state.active })}
                                                    />
                                                    </Form.Field>
                                            </Form>
                                            </Table.Cell>
                                        <Table.Cell textAlign="center" verticalAlign="middle">
                                                <Button color="blue" circular icon="check" onClick={this.add} />

                                                <Button
                                                    color="blue"
                                                    basic="true"
                                                    circular
                                                    icon="close"
                                                    onClick={() => this.setState({
                                                        name: null, nameErr: false, editMode: false, addNewSystematization: false
                                                    })}
                                            />

                                            </Table.Cell>
                                        </Table.Row>}
                                        {this.state.data.map((el, index) =>
                                            (<Table.Row key={index}>
                                                <Table.Cell verticalAlign="middle">
                                                    {editMode === index ?
                                                        <Form>
                                                            <Form.Field
                                                                required
                                                                error={this.state.nameErr}
                                                                control={Input}
                                                                name="name"
                                                                value={this.state.name}
                                                                onChange={this.handleInputChange}
                                                                placeholder="Unesite naziv sistematizacije"
                                                            />
                                                        </Form>
                                                        : el.name}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {editMode === index ?
                                                        <Form>
                                                            <Form.Field>
                                                                <Checkbox
                                                                    checked={this.state.active}
                                                                    label=""
                                                                    value={this.state.active}
                                                                    onChange={(e) => this.setState({ active: !this.state.active })}
                                                                />
                                                            </Form.Field>
                                                        </Form>
                                                        : el.active ? 'DA' : 'NE'}
                                                </Table.Cell>
                                                {editMode === index ?
                                                    <Table.Cell verticalAlign="middle" textAlign="center">
                                                        <Button color="blue" onClick={this.edit} circular icon="check" />
                                                        <Button
                                                            color="blue"
                                                            circular
                                                            icon="close"
                                                            basic="true"
                                                            onClick={() => this.setState({
                                                                name: null, nameErr: false, editMode: false, addNewSystematization: false
                                                            })}
                                                        />
                                                    </Table.Cell>
                                                    : <Table.Cell verticalAlign="middle" textAlign="center">
                                                        <Popup
                                                            content="Pozicije"
                                                            position="top center"
                                                            trigger={
                                                                <Button
                                                                    icon="list ul"
                                                                    size="small"
                                                                    basic="true"
                                                                    color="blue"
                                                                    circular
                                                                    onClick={() => { this.setState({ showPosition: true }); localStorage.setItem('systematization', JSON.stringify(el)); }}
                                                                />}
                                                        />
                                                        {localStorage.getItem('activeRole').substr(0, 18) !== 'HR admin: Rektorat' && <Popup
                                                            content="Izmjena"
                                                            position="top center"
                                                            trigger={
                                                                <Button
                                                                    color="green"
                                                                    basic="true"
                                                                    size="small"
                                                                    circular
                                                                    icon="pencil"
                                                                    onClick={() => this.setState({
                                                                        name: el.name, active: el.active, editMode: index, id: el.id, optLock: el.optLock
                                                                    })}
                                                                />
                                                            }
                                                        />}
                                                        {localStorage.getItem('activeRole').substr(0, 18) !== 'HR admin: Rektorat' && <Popup
                                                            content="Brisanje"
                                                            position="top center"
                                                            trigger={
                                                                <Button color="red" basic="true" size="small" circular icon="trash alternate" onClick={() => this.delete(el.id)} />
                                                            }
                                                        />}


                                                    </Table.Cell>}
                                            </Table.Row>
                                            ))}
                                    </Table.Body> : 'Nema sistematizacija.'}
                            </Table>}
                        </Fragment>}
                    </Segment>
                </Segment.Group>
                <ToastContainer hideProgressBar />

            </div>);
    }
}




// WEBPACK FOOTER //
// ./src/views/HR/Systematization/Systematization.js